import axios from 'axios';
import {
  LinkedManufacturesUrl,
  MyBenefitsUrl,
  OverviewDetailsUrl,
} from '../url';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';

export const LinkedManufacturesAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${LinkedManufacturesUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const OverViewDetailAction = async (manufacturerId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const params = {
      manufacturer_id: manufacturerId,
    };
    await axios
      .get(OverviewDetailsUrl(), { ...getTokenHeader(token), params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const MyBenefitsAction = async (manufacturerId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${MyBenefitsUrl()}?manufacturer_id=${manufacturerId}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

